import React from 'react';
import { Link } from 'react-router-dom';
import routes from '../../routes/routes';

const Footer = () => {
    const usefulLinksLeft = [
        { name: "A propos", path: routes.presentation },
    ];

    const usefulLinksRight = [
        { name: "Les comités", path: routes.comites },
    ];

    const mentionsLegales = [
        { name: "Proposer un article", path: routes.proposition },
        { name: "Crédits", path: routes.credits },
        { name: "Politique de publication", path: routes.politique },
    ];

    return (
        <footer className="bg-blueprimary text-white w-full">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 py-12">
                    <div className="sm:col-span-2 lg:col-span-1">
                        <h2 className="text-3xl tracking-tighter font-semibold">
                            MAD<span className="text-greenlogo">ATLAS</span>
                            <span className="text-danger">.</span>
                        </h2>
                    </div>

                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold">Liens utiles</h3>
                        <ul className="space-y-2.5">
                            {usefulLinksLeft.map((link) => (
                                <li
                                    key={link.name}
                                    className="flex items-center group"
                                >
                                    <div className="w-1.5 h-1.5 rounded-full bg-white/70 group-hover:bg-white transition-colors duration-300 mr-2"></div>
                                    <Link
                                        to={link.path}
                                        className="text-sm text-white/80 hover:text-white transition-colors duration-300"
                                    >
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold">Liens utiles</h3>
                        <ul className="space-y-2.5">
                            {usefulLinksRight.map((link) => (
                                <li
                                    key={link.name}
                                    className="flex items-center group"
                                >
                                    <div className="w-1.5 h-1.5 rounded-full bg-white/70 group-hover:bg-white transition-colors duration-300 mr-2"></div>
                                    <Link
                                        to={link.path}
                                        className="text-sm text-white/80 hover:text-white transition-colors duration-300"
                                    >
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="space-y-4 sm:col-span-2 lg:col-span-1">
                        <h3 className="text-lg font-semibold">Mentions légales :</h3>
                        <ul className="space-y-2.5">
                            {mentionsLegales.map((link) => (
                                <li
                                    key={link.name}
                                    className="flex items-center group"
                                >
                                    <div className="w-1.5 h-1.5 rounded-full bg-white/70 group-hover:bg-white transition-colors duration-300 mr-2"></div>
                                    <Link
                                        to={link.path}
                                        className="text-sm text-white/80 hover:text-white transition-colors duration-300"
                                    >
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="border-t border-white/10 py-6">
                    <div className="flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                        <p className="text-xs text-white/70 hover:text-white transition-colors">
                            © 2024 ATLAS Project. Tout droits réservés
                        </p>
                        <p className="text-xs text-white/70 hover:text-white transition-colors">
                            Création du site : ITDC Mada
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;